<!-- 行业动态 -->
<template>
  <div class="frame">
    <Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="wrap">
      <div class="left">
        <div class="in">
          <div class="link-map">
            <div class="title">培训分类</div>
            <div class="subs">
              <div
                :class="{
                  sub: true,
                  active: queryParams.trainTypeName == item.typeName,
                }"
                v-for="item in types"
                :key="item.id"
                @click="choseTrainType(item.typeName)"
              >
                {{ item.typeName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="label-title">
          <span>{{ $route.name }}</span>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="navToDetail(item)"
          >
            <div class="info">
              <img
                src="@/assets/pdf.png"
                class="icon"
                v-if="item.fileType == 'pdf'"
              />
              <img
                src="@/assets/ppt.png"
                class="icon"
                v-else-if="pptTypes.includes(item.fileType)"
              />
              <img src="@/assets/video.png" class="icon" v-else />
              <div class="center">
                <div class="title">{{ item.title }}</div>
                <div class="type">{{ item.trainTypeName }}</div>
              </div>
              <div class="time">{{ item.createTime.split(" ")[0] }}</div>
            </div>
          </div>
        </div>
        <div class="empty" v-show="list.length == 0">
          <el-empty description="暂无相关培训"></el-empty>
        </div>
        <el-pagination
          class="pagination"
          background
          :hide-on-single-page="totalData < 11"
          @current-change="currentChange"
          :current-page.sync="queryParams.pageIndex"
          :page-size="queryParams.pageSize"
          layout="prev, pager, next"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/breadCrumb.vue";
import { URL } from "../util/config";
export default {
  components: { Breadcrumb },
  data() {
    return {
      URL,
      breadcrumbs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        trainTypeName: "",
      },
      types: [],
      list: [],
      totalData: 0,
      pptTypes: ["ppt", "pptx"],
    };
  },
  created() {
    this.breadcrumbs = [
      { path: "/", name: "首页" },
      { name: this.$route.name },
    ];
    this.getDic();
    if (this.$route.query.type) {
      this.queryParams.trainTypeName = this.$route.query.type;
    }
    this.getList();
  },
  methods: {
    async getDic() {
      let res = await this.$api.getTrainDic();
      this.types = res.data;
    },
    choseTrainType(type) {
      let { trainTypeName } = this.queryParams;
      this.queryParams.trainTypeName = trainTypeName == type ? "" : type;
      this.getList();
    },
    currentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getTrainList(this.queryParams);
      this.list = res.data.list.map((ele) => {
        if (ele.contentStr) {
          const devideArr = ele.contentStr.split(".");
          ele.fileType = devideArr[devideArr.length - 1];
        }
        return ele;
      });
      this.totalData = res.data.total;
    },
    navToDetail(item) {
      this.$router.push("/trainDetail/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 1200px;
  min-height: 50vh;
  display: flex;
  margin: 0 auto;

  .left {
    width: 25%;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;

    .in {
      position: sticky;
      left: 0;
      top: 30px;
      background-color: #fff;

      .title {
        color: #fff;
        background: $theme;
        font-weight: bold;
        padding: 7px 10px;
        margin-bottom: 10px;
      }
      .subs {
        .sub {
          border-bottom: 1px dashed #7d7d7d;
          margin: 2px 0 5px;
          line-height: 36px;
          font-size: 12px;
          position: relative;
          text-align: center;

          &:hover {
            background-color: #fef0f0;
            border-color: $theme;
            color: $theme;
            cursor: pointer;

            &::after {
              border-left-color: $theme;
            }
          }

          &::after {
            content: "";
            display: block;
            width: 0px;
            height: 0px;
            border: 5px solid transparent;
            border-left-color: #7e7e7e;
            position: absolute;
            left: 0;
            top: 13px;
          }
        }
        .active {
          background-color: #fef0f0;
          border-color: $theme;
          color: $theme;
          cursor: pointer;

          &::after {
            border-left-color: $theme;
          }
        }
      }
    }
  }
  .right {
    width: 75%;
    padding: 0 20px;
    box-sizing: border-box;

    .label-title {
      padding: 0 20px 0 70px;
      position: relative;

      &::before {
        content: "";
        width: 100%;
        height: 1px;
        background: #ccc;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }

      span {
        padding: 5px 20px;
        border-radius: 18px;
        background: #a4a4a4;
        color: #fff;
        position: relative;
        z-index: 2;

        &::before,
        &::after {
          content: "";
          width: 7px;
          height: 7px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: #ccc;
          border-radius: 50%;
        }
        &::before {
          left: -20px;
        }
        &::after {
          right: -20px;
        }
      }
    }

    .list {
      padding: 25px 0;

      .item {
        padding: 10px;
        border-bottom: 1px solid #eeeeee;
        background-color: #fff;
        transition: 0.5s;

        &:hover {
          box-shadow: 0 0 10px #ddd;
          border-radius: 10px;
          transform: translateY(-10px);
          cursor: pointer;

          .title {
            color: $theme;
          }
        }

        .info {
          width: 100%;
          display: flex;
          align-items: center;

          .icon {
            width: 30px;
          }
        }
        .center {
          flex-grow: 1;
        }
        .title {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0 10px;
        }
        .type {
          font-size: 12px;
          color: #666;
          padding: 3px 10px;
          margin: 4px 0;
        }
        .time {
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
}
</style>
